import AsyncDropdown from "../../../../Common/components/Dropdowns/Async";
import { Mui } from "@osu/react-ui";
import useCountriesData from "../../../../Common/hooks/useCountriesData";

const filterOptions = Mui.createFilterOptions({
  ignoreAccents: true,
  ignoreCase: true,
  matchFrom: 'start',
  trim: true
});

function CountryDropdown(props = {}) {
  const {
  value,
  setValue,
  id,
  required,
  error,
  label,
  onChange,
  name,
  helperText,
  description,
  excludeOptions,
  ...rest
} = props

const { data, loading } = useCountriesData()
  let options = Array.isArray(data) ? data : [];
  if (excludeOptions?.length) {
    const excluded = excludeOptions.map(v => v.toUpperCase());
    options = options.filter(option => !excluded.includes(option.name.toUpperCase()));
  }
  const inputLabelId = `${id}-label`;
  const descriptionId = `${id}-description`;
  let selectedOption = {}

  if (value?.name) {
    selectedOption = value;
  } else if (value) {
    const match = options.find((option) => option.name === value || option === value);
    if(match) {
      selectedOption = match
    } else if (typeof value === 'string') {
      selectedOption = {
        name: value
      }
    }
  }

  return (
    <Mui.FormGroup {...rest}>
      {label && (
        <Mui.FormLabel
          variant="body1"
          id={inputLabelId}
          required={required}
          error={error}
        >
          {label}
        </Mui.FormLabel>
      )}
      {description && (
        <Mui.Typography sx={{ 
          marginBottom: 1,
        }} id={descriptionId} variant="body2" component="span">
          {description}
        </Mui.Typography>
      )}
      <AsyncDropdown
        filterOptions={filterOptions} 
        aria-describedby={description ? descriptionId : undefined}
        aria-labelledby={label ? inputLabelId : undefined}
        loading={loading}
        options={options}
        freeSolo
        disableClearable={required}
        placeholder={label || "Select a country"}
        getOptionLabel={(option) => {
          return option?.name || "";
        }}
        id={id}
        name={name}
        getOptionKey={({ name = "", isoCode = "" }) =>{
          return encodeURIComponent(isoCode + name)
        }}
        onChange={(event, newValue) => {
          if(onChange) {
            onChange(event, newValue)
          }
          setValue(newValue);
        }}
        value={selectedOption}
        helperText={helperText}
        error={error}
        required={required}
        {...rest}
      />
    </Mui.FormGroup>
  );
}

export default CountryDropdown;
